import React, { useState, useEffect } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CForm,
  CFormLabel,
  CFormInput,
  CFormSelect,
  CButton,
  CRow,
  CCol,
} from "@coreui/react";
import { getAllCategories } from "src/services/Products";

const ProductFilter = ({ open, onClose, onApply, initialFilters }) => {
  const [filters, setFilters] = useState(
    initialFilters || {
      name: "",
      sku: "",
      categoryId: "",
    }
  );
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [loadingCategory, setLoadingCategory] = useState(false);


  // Fetch Category options for the dropdown
  useEffect(() => {
    const fetchCategoryOptions = async () => {
      setLoadingCategory(true);
      try {
        const response = await getAllCategories();
        const categoryData = response?.categories || response || [];
        const options = categoryData.map((category) => ({
          value: category.id,
          label: `${category.name}`,
        }));
        setCategoryOptions(options);
      } catch (error) {
        console.error("Error fetching Category options:", error);
        setCategoryOptions([]);
      } finally {
        setLoadingCategory(false);
      }
    };

    if (open) {
      fetchCategoryOptions();
    }
  }, [open]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onApply(filters);
  };

  const handleReset = () => {
    setFilters({
      name: "",
      sku: "",
      categoryId: "",
    });
    onApply({}); // Apply empty filters to reset
  };

  return (
    <CModal visible={open} onClose={onClose} size="lg">
      <CModalHeader>
        <CModalTitle>Filter Produk</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol md={6}>
              <CFormLabel>Nama Produk</CFormLabel>
              <CFormInput
                type="text"
                name="name"
                value={filters.name}
                onChange={handleInputChange}
                placeholder="Cari berdasarkan nama"
              />
            </CCol>
            <CCol md={6}>
              <CFormLabel>Kategori Produk</CFormLabel>
              <CFormSelect 
                name="categoryId" 
                value={filters.categoryId} 
                onChange={handleInputChange}
                disabled={loadingCategory}
              >
                <option value="">Semua Kategori</option>
                {categoryOptions.map((category) => (
                  <option key={category.value} value={category.value}>
                    {category.label}
                  </option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>

          <CRow className="mb-3">
          <CCol md={6}>
              <CFormLabel>SKU</CFormLabel>
              <CFormInput
                type="text"
                name="sku"
                value={filters.sku}
                onChange={handleInputChange}
                placeholder="Cari berdasarkan SKU"
              />
            </CCol>
          </CRow>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleReset}>
          Reset
        </CButton>
        <CButton color="primary" onClick={handleSubmit}>
          Terapkan Filter
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ProductFilter;
